import { createApiOperation } from "../api-client/create-api-operation";

export const Zotero = {
  sync: createApiOperation<
    never,
    "/Api/References/ZoteroSynchronization",
    "post"
  >("/Api/References/ZoteroSynchronization", "post"),
  getStatus: createApiOperation<
    never,
    "/Api/References/ZoteroSynchronization",
    "get"
  >("/Api/References/ZoteroSynchronization", "get"),
};
